// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "closeRfqSideNavRightData": {
      "slide": "PUSH",
      "direction": "RIGHT_TO_LEFT",
      "animation": false,
      "width": "WIDE",
      "height": "FULL"
    },
    "comments": {
      "displayName": "Comments",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "true",
      "requiredText": "Please enter comments here",
      "numberOfLines": 5
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqid": {
      "type": "string"
    }
  },
  "actions": {
    "closeRfq": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation processRfq( $collaborationspaceId: String, $rfqId: String, $rfqQuoteId: String, $comments: String, $status: String) { processRfq( collaborationspaceId: $collaborationspaceId, rfqId: $rfqId, rfqQuoteId: $rfqQuoteId, comments: $comments, status: $status) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqId": "{{ctx.rfq.rfqid || props.rfqid}}",
              "comments": "{{data.comments.dbValue}}",
              "status": "Closed"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "response": "data.data.processRfq",
        "errorCode": "errorCode"
      },
      "events": {
        "success": [{
          "condition": "response.error === undefined",
          "name": "close-rfq.success",
          "eventData": {
            "response": "{{response}}"
          }
        }, {
          "condition": "response.error === undefined",
          "name": "updateRfqDetailLabelsConsolidateView",
          "eventData": {
            "response": "{{response}}"
          }
        }, {
          "condition": "response.error === 'EMPTY_COLLAB_SPACE'",
          "name": "close-rfq.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "response.error.statusCode === 400 || errorCode === 400",
          "name": "close-rfq.error",
          "eventData": {
            "error": "{{response.error}}"
          }
        }, {
          "condition": "response.error.statusCode === 403 || errorCode === 403",
          "name": "close-rfq.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "response.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "close-rfq.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "response.error.statusCode >= 500 && response.error.statusCode <= 599",
          "name": "close-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "close-rfq.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "onEvent": [{
    "eventId": "close-rfq.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-close-rfq.success"
    }
  }, {
    "eventId": "close-rfq.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-close-rfq.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "conditions": {},
  "i18n": {
    "Close": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "CloseRfq",
  "_uniqueViewModelId": "CloseRfq",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <table height="">
        <tr class="tableBody">
            <td>
                <aw-textarea prop="data.comments"></aw-textarea>
            </td>
            </tr>
            <tr class="tableFooter">
                <td>
                    <aw-button action="closeRfq" size="auto">{{i18n.Close}}</aw-button>
                </td>
            </tr>
    </table>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableBody"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwTextarea, getField("data.comments", fields, $index, null, null)))), /*#__PURE__*/React.createElement("tr", {
    className: "tableFooter"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwButton, {
    action: actions.closeRfq,
    size: "auto"
  }, AwParseService.instance("i18n.Close")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;